export default "__VITE_ASSET__CDKSli0D__"